import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxImageCompressService } from 'ngx-image-compress';

import { ModalContainerComponent } from './components/modal-container/modal-container.component';
import { AlertModalComponent } from './components/modals/alert-modal/alert-modal.component';
import { ConfirmModalComponent } from './components/modals/confirm-modal/confirm-modal.component';
import { CodeModalComponent } from './components/modals/code-modal/code-modal.component';
import { EditPhotoComponent } from './components/modals/edit-photo/edit-photo.component';
import { FeedbackModalComponent } from './components/modals/feedback-modal/feedback-modal.component';
import { FileUploadModalComponent } from './components/modals/file-upload-modal/file-upload-modal.component';
import { UploadTaskModalComponent } from './components/modals/upload-task-modal/upload-task-modal.component';
import { PreloaderComponent } from '../shared/components/preloader/preloader.component';
import { DynamicFormComponent } from '../shared/components/dynamic-form/dynamic-form.component';
import { PhotoCropperComponent } from '../shared/components/photo-cropper/photo-cropper.component';
import { HelpModalComponent } from './components/modals/help-modal/help-modal.component';

@NgModule({
  declarations: [
    ModalContainerComponent,
    AlertModalComponent,
    ConfirmModalComponent,
    CodeModalComponent,
    EditPhotoComponent,
    FeedbackModalComponent,
    HelpModalComponent,
    FileUploadModalComponent,
    UploadTaskModalComponent,
  ],
  exports: [ModalContainerComponent],
  imports: [
    CommonModule,
    NgbAlertModule,
    PreloaderComponent,
    DynamicFormComponent,
    PhotoCropperComponent,
  ],
  providers: [NgxImageCompressService],
})
export class AppModalsModule {}
